import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import SnackbarProvider from 'react-simple-snackbar';
import { config } from './config';

debugger;
console.log('hola -----------------------------', new Date());

ReactDOM.render(
  <SnackbarProvider>
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      audience={config.audience}
      redirectUri={window.location.origin}
      scope="offline_access read:authenticators remove:authenticators enroll"
    >
      <App />
    </Auth0Provider>
  </SnackbarProvider>,
  document.getElementById('root'),
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
